import { uniqPrimativeMerge } from '../../utils/arrayUtils';
import { ILookup, INumHash } from '../lookups';
import { ProspectsActionKeys as keys } from './prospectsActionKeys';
import { ProspectsTypes } from './prospectsActionTypes';
import { IProspect, IProspectApiResponse } from './prospectsInterfaces';

export interface IProspectsState {
  ids: number[];
  hash: INumHash<IProspect>;
  loading: boolean;
  saving: number[];
  totalItems: {
    [index: number]: { [index: string]: number };
  };
}

const initialState: IProspectsState = {
  hash: {},
  ids: [],
  loading: false,
  saving: [],
  totalItems: {}
};

export function prospectsReducer(state: IProspectsState = initialState, action: ProspectsTypes): IProspectsState {
  switch (action.type) {
    case keys.CHANGE_LIFECYCLE_STEP_FULFILLED:
      return {
        ...state,
        hash: {
          ...state.hash,
          [action.payload.id]: {
            ...state.hash[action.payload.id],
            prospectLifeCycleStepId: action.payload.newStateId
          }
        }
      };
    case keys.SET_PROSPECTS:
      const updates = processProspect([...action.payload], state.ids);

      return {
        ...state,
        hash: { ...state.hash, ...updates.hash },
        ids: updates.ids
      };
    case keys.HIDE_PROSPECTS_LOADING:
      return {
        ...state,
        loading: false
      };
    case keys.SAVE_COMPLETE:
      return {
        ...state,
        saving: state.saving.filter(s => s !== action.payload.prospectId)
      };
    case keys.SET_PROSPECT_TOTAL_ITEMS:
      return {
        ...state,
        totalItems: {
          ...state.totalItems,
          [action.payload.prospectStatusId]: action.payload.totalItems
        }
      };
    case keys.SHOW_PROSPECTS_LOADING:
      return {
        ...state,
        loading: true
      };
    case keys.UPDATE_PROSPECT:
      return {
        ...state,
        saving: uniqPrimativeMerge(state.saving, action.payload.prospectId)
      };
    case keys.UPDATE_PROSPECT_FULFILLED:
      return {
        ...state,
        hash: {
          ...state.hash,
          [action.payload.prospectId]: action.payload
        },
        saving: state.saving.filter(s => s !== action.payload.prospectId)
      };
    default:
      return state;
  }
}

function processProspect(prospects: IProspectApiResponse[], currentIds: number[]): ILookup<IProspect> {
  let ids = prospects.map(p => p.prospectId);
  const hash = prospects.reduce<INumHash<IProspect>>(
    (newHash, p) => ({
      ...newHash,
      [p.prospectId]: {
        ...p,
        addresses: p.addresses.map(a => a.addressId)
      }
    }),
    {}
  );

  // a set can only have single instances of
  ids = uniqPrimativeMerge(ids, currentIds);
  return {
    hash,
    ids
  };
}
